<template>
<el-container>
  <div v-if="ismobile === false">
    <publicHeader :currencyShow="currencyShow" @hotelLanguage="hotelLanguage"></publicHeader>
  </div>
  <div v-else>
    <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
      <router-link :to="{name:'Home', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}">
        <i class="el-icon-arrow-left" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;" @click="goback()"></i>
      </router-link>
      <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('coupon')}}</div>
    </div>
  </div>
  <el-main>
    <div class="main" :style="{ 'min-height': `${elementHeight}px` }">
      <publicAccountMenu></publicAccountMenu>
      <div class="account-show">
        <div class="account-center">
          <div class="account-data-info">
            <div class="clearBoth account-roominfo-clear"></div>
            <!-- 状态 开始 -->
            <div class="account-data-status account-data-status-pc">
              <div class="account-data-status-center">
                <div class="status-first" @click="clickActive('valid')" :class="{'status-active':validShow}">{{$t('unUsed')}}</div>
                <div @click="clickActive('used')" :class="{'status-active':usedShow}">{{$t('used')}}</div>
                <div class="status-last" @click="clickActive('expired')" :class="{'status-active':expiredShow}">{{$t('expired')}}</div>
              </div>
            </div>
            <!-- 状态 结束 -->
            <div class="home-coupon">
              <div class="home-coupon-empty" v-show="couponEmptyShow" v-if="ismobile === false">
                <div><img src="/static/img/account/coupon-no.png" class="empty-img"></div>
                <div class="empty-text">{{$t('noCoupon')}}</div>
              </div>
              <div class="home-coupon-empty" v-show="couponEmptyShow" v-else>
                <div><img src="/static/img/account/coupon-no.png" class="empty-img-mobile"></div>
                <div class="empty-text">{{$t('noCoupon')}}</div>
              </div>
            </div>
            <div class="coupon-pc">
              <div v-if="ismobile === false">
                <el-skeleton :count="5" animated :loading="couponLoading">
                  <template slot="template">
                      <el-skeleton-item variant="text" style="width: 805px; height: 165px; border-radius: 5px 5px 5px 5px; margin: 0px 10px 25px 10px;"/>
                  </template>
                  <template>
                    <div v-for="(value, key) in myCouponList" :key="key">
                      <div>
                        <div class="coupon-back">
                          <div class="dotted-line">
                            <img src="/static/img/account/u163.svg" style="width: 117px;height: 2px;">
                          </div>
                          <!-- 内容展示 开始 -->
                            <!-- 优惠券金额 开始 -->
                            <div class="coupon-money">
                              <div v-if="value.immediately !== ''">
                                <img class="coupon-code" src="/static/img/account/cny-code.svg" v-if="resultCurrency === 'CNY'">
                                <img class="coupon-code" src="/static/img/account/usd-code.svg" v-else>
                                <span class="coupon-price">{{value.immediately}}</span>
                              </div>
                              <div v-if="value.discount !== ''">
                                <span class="coupon-price">{{value.discount}}</span>
                              </div>
                            </div>
                            <!-- 优惠券金额 结束 -->
                            <!-- 优惠券介绍 开始 -->
                            <div :class="{'coupon-info':  (language === 'zh' && (value.valid_date_zh !== '' || value.explain_zh !== '')) || (language === 'en' && (value.valid_date_en !== '' || value.explain_en !== '')), 'coupon-info-onlytitle': (language === 'zh' && value.valid_date_zh === '' && value.explain_zh === '') || (language === 'en' && value.valid_date_en === '' && value.explain_en === '')}">
                              <div class="coupon-title" v-if="language === 'zh'">{{value.price_val_zh}}</div>
                              <div class="coupon-title" v-else>{{value.price_val_en}}</div>
                              <div style="font-size: 14px;margin-bottom: 8px;" v-if="value.valid_date_zh !== ''">
                                <span class="coupon-text-black">{{$t('validDate')}}</span>
                                <span class="coupon-text-gary" v-if="language === 'zh'">{{value.valid_date_zh}}</span>
                                <span class="coupon-text-gary" v-else>{{value.valid_date_en}}</span>
                              </div>
                              <div style="font-size: 14px;" v-if="language === 'zh' && value.explain_zh !== ''">
                                <span class="coupon-text-black">T&C:</span>
                                <span class="coupon-text-gary">{{value.explain_zh}}</span>
                              </div>
                              <div style="font-size: 14px;" v-if="language === 'en' && value.explain_en !== ''">
                                <span class="coupon-text-black">T&C:</span>
                                <span class="coupon-text-gary">{{value.explain_en}}</span>
                              </div>
                            </div>
                            <!-- 优惠券介绍 结束 -->
                            <!-- 去使用 开始 -->
                            <div class="coupon-button">
                              <div class="coupon-button-info coupon-button-info-valid" style=" cursor: pointer;" v-show="validShow" @click="gotoHome">{{$t('useNow')}}</div>
                              <div class="coupon-button-info coupon-button-info-used" v-show="usedShow">{{$t('used')}}</div>
                              <div class="coupon-button-info coupon-button-info-expired" v-show="expiredShow">{{$t('expired')}}</div>
                            </div>
                            <!-- 去使用 开始 -->
                          <!-- 内容展示 结束 -->
                        </div>
                      </div>
                    </div>
                  </template>
                </el-skeleton>
              </div>
              <div v-else>
                <el-skeleton :count="5" animated :loading="couponLoading">
                  <template slot="template">
                      <el-skeleton-item variant="text" style="width: 96%;height: 86px; border-radius: 5px 5px 5px 5px; margin: 0px 2% 20px 2%;"/>
                  </template>
                  <template>
                    <div v-for="(value, key) in myCouponList" :key="key">
                      <div>
                        <div class="coupon-back-mobile">
                          <!-- <div class="dotted-line-mobile">
                            <img src="/static/img/account/u163.svg" style="width: 59px;height: 2px;">
                          </div> -->
                          <!-- 内容展示 开始 -->
                            <!-- 优惠券金额 开始 -->
                            <div class="coupon-money-mobile">
                              <div v-if="value.immediately !== ''">
                                <img class="coupon-code-mobile" src="/static/img/account/cny-code.svg" v-if="resultCurrency === 'CNY'">
                                <img class="coupon-code-mobile" src="/static/img/account/usd-code.svg" v-else>
                                <span class="coupon-price-mobile">{{value.immediately}}</span>
                              </div>
                              <div v-if="value.discount !== ''">
                                <span class="coupon-price-mobile">{{value.discount}}</span>
                              </div>
                            </div>
                            <!-- 优惠券金额 结束 -->
                            <!-- 优惠券介绍 开始 -->
                            <div :class="{'coupon-info-mobile':  (language === 'zh' && (value.valid_date_zh !== '' || value.explain_zh !== '')) || (language === 'en' && (value.valid_date_en !== '' || value.explain_en !== '')), 'coupon-info-onlytitle-mobile': (language === 'zh' && value.valid_date_zh === '' && value.explain_zh === '') || (language === 'en' && value.valid_date_en === '' && value.explain_en === '')}">
                              <div :class="{'coupon-title-mobile': value.valid_date_zh !== '' && value.explain_zh !== '', 'coupon-title-twoline-mobile': (value.valid_date_zh === '' && value.explain_zh !== '') || (value.valid_date_zh !== '' && value.explain_zh === '')}" v-if="language === 'zh'">{{value.price_val_zh}}</div>
                              <div :class="{'coupon-title-mobile': value.valid_date_en !== '' && value.explain_en !== '', 'coupon-title-twoline-mobile': (value.valid_date_en === '' && value.explain_en !== '') || (value.valid_date_en !== '' && value.explain_en === '')}" v-else>{{value.price_val_en}}</div>
                              <div style="font-size: 10px;margin-bottom: 4px; height: 25px;" v-if="value.valid_date_zh !== ''">
                                <span class="coupon-text-gary" v-if="language === 'zh'">{{value.valid_date_zh}}</span>
                                <span class="coupon-text-gary" v-else>{{value.valid_date_en}}</span>
                              </div>
                              <div class="explain-info" v-if="language === 'zh' && value.explain_zh !== ''">
                                <span class="coupon-text-black" style="float: left;">T&C</span>
                                <span style="float: left; margin-top: 2px; margin-left: 5px;">
                                  <img src="https://res.roompai.com/static/img/order/tanhao.png" style="width:12px; height:12px; cursor: pointer;" @click="explainZhDiaShow(key)">
                                  <el-dialog :visible.sync="explainZhDia" :width="diaWidth" :show-close="explainShowClose" class="tax-margin" top="35vh" v-if="cur === key">
                                    <div slot="title" style="text-align: center;font-size: 16px;color: #303133;">T&C</div>
                                    <div style="font-size: 12px; color: #303133; text-align: left; line-height: 24px;margin:-30px -5px 0px -5px;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">{{value.explain_zh}}</div>
                                    <div @click="explainZhDia = false" style="border-top: 1px solid rgba(221, 223, 226, 1);font-weight: 100; font-style: normal; font-size: 16px; color: #5392F9; text-align: center; line-height: 50px; height: 50px;margin: 20px -5px -30px -5px;">
                                      {{$t('close')}}
                                    </div>
                                  </el-dialog>
                                </span>
                              </div>
                              <div class="explain-info" v-if="language === 'en' && value.explain_en !== ''">
                                <span class="coupon-text-black" style="float: left;">T&C</span>
                                <span style="float: left; margin-top: 2px; margin-left: 5px;">
                                  <img src="https://res.roompai.com/static/img/order/tanhao.png" style="width:12px; height:12px; cursor: pointer;" @click="explainEnDiaShow(key)">
                                  <el-dialog :visible.sync="explainEnDia" :width="diaWidth" :show-close="explainShowClose" class="tax-margin" top="35vh" v-if="cur === key">
                                    <div slot="title" style="text-align: center;font-size: 16px;color: #303133;">T&C</div>
                                    <div style="font-size: 12px; color: #303133; text-align: left; line-height: 24px;margin:-30px -5px 0px -5px;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">{{value.explain_en}}</div>
                                    <div @click="explainEnDia = false" style="border-top: 1px solid rgba(221, 223, 226, 1);font-weight: 100; font-style: normal; font-size: 16px; color: #5392F9; text-align: center; line-height: 50px; height: 50px;margin: 20px -5px -30px -5px;">
                                      {{$t('close')}}
                                    </div>
                                  </el-dialog>
                                </span>
                              </div>
                            </div>
                            <!-- 优惠券介绍 结束 -->
                            <!-- 去使用 开始 -->
                            <div class="coupon-button-mobile">
                              <div class="coupon-button-info-mobile coupon-button-info-valid" style=" cursor: pointer;" v-show="validShow" @click="gotoHome">{{$t('useNow')}}</div>
                              <div class="coupon-button-info-mobile coupon-button-info-used" v-show="usedShow">{{$t('used')}}</div>
                              <div class="coupon-button-info-mobile coupon-button-info-expired" v-show="expiredShow">{{$t('expired')}}</div>
                            </div>
                            <!-- 去使用 开始 -->
                          <!-- 内容展示 结束 -->
                        </div>
                      </div>
                    </div>
                  </template>
                </el-skeleton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-main>
  <div class="clearBoth"></div>
  <publicFooter></publicFooter>
</el-container>
</template>

<script>
import { myCoupon } from '@/request/coupon.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import publicAccountMenu from '@/components/public/publicAccountMenu'
export default {
  name: 'myCoupon',
  components: {
    publicFooter,
    publicHeader,
    publicAccountMenu
  },
  data () {
    return {
      orderno: '',
      myCouponList: {},
      myValidCouponList: {},
      myUsedCouponList: {},
      myExpiredCouponList: {},
      couponShow: false,
      couponEmptyShow: false,
      language: this.common.languageSet(this),
      currency: this.common.currencySet(this),
      elementHeight: 0,
      ismobile: false,
      resultCurrency: '',
      start: '',
      end: '',
      currencyShow: false,
      source: 'roompai',
      validShow: true,
      usedShow: false,
      expiredShow: false,
      explainZhDia: false,
      explainShowClose: false,
      diaWidth: '500px',
      explainEnDia: false,
      cancelEnDia: false,
      cur: '',
      couponLoading: true,
      timeZone: '',
      conver: ''
    }
  },
  created () {
    this.beforeMount()
  },
  mounted: function () {
    if (document.documentElement.clientWidth < 1100) {
      this.ismobile = true
      this.diaWidth = '95%'
    } else {
      this.ismobile = false
      this.diaWidth = '500px'
    }
    // 判断来源
    var source = this.common.linkQuerys.source
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    }
    var conver = this.common.linkQuerys.conver
    if (conver === 1 || conver === '1') {
      this.conver = conver
    }
    var token = localStorage.getItem('token')
    if (token === undefined || token === null || token === 'null') {
      let locationHref = window.document.location.href
      sessionStorage.setItem('LoginWebsiteAddress', locationHref)
      // this.$router.push({name: 'login', query: {'source': this.source}})
      var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
      }
      this.$router.push({name: 'login', params: {'querys': newQuerys}})
    }
    this.getMyCoupon()
  },
  watch: {
    currency: function (newCur, oldCur) {
      this.getMyCoupon()
      this.clickActive('valid')
    },
    language: function (newCur, oldCur) {
      this.getMyCoupon()
      this.clickActive('valid')
    }
  },
  methods: {
    beforeMount () {
      this.elementHeight = document.documentElement.clientHeight || document.body.clientHeight
    },
    hotelDetailCurrency (currency) {
      this.currency = currency
    },
    hotelLanguage (language) {
      this.language = language
    },
    getMyCoupon () {
      this.common.stopScroll()
      var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
      }
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      if (token === undefined) {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        this.$router.push({name: 'login', params: {'querys': newQuerys}})
      }
      this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
      console.log('timeZone', this.timeZone)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'source': this.source, 'time': time, 'language': this.language, 'token': token, 'sessionid': sessionid, 'currency': this.currency, 'timeZone': this.timeZone}
      var data = this.common.encryptionData(dataJson, this)
      myCoupon(data).then(res => {
        if (res.flag === '001') {
          let locationHref = window.document.location.href
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (res.flag === '200' && res.data !== '') {
          this.myValidCouponList = res.data.list.valid
          this.myUsedCouponList = res.data.list.used
          this.myExpiredCouponList = res.data.list.expired
          console.log('myValidCouponList', this.myValidCouponList)
          console.log('myUsedCouponList', this.myUsedCouponList)
          console.log('myExpiredCouponList', this.myExpiredCouponList)
          this.myCouponList = this.myValidCouponList
          this.couponShow = true
          this.couponEmptyShow = false
          this.couponLoading = false
          this.resultCurrency = res.data.currency
        } else {
          this.myValidCouponList = {}
          this.myUsedCouponList = {}
          this.myExpiredCouponList = {}
          this.myCouponList = {}
          this.couponShow = false
          this.couponEmptyShow = true
          this.couponLoading = false
        }
      })
      this.common.canScroll()
    },
    clickActive: function (type) {
      this.type = type
      // 默认都不展示.
      this.validShow = false
      this.usedShow = false
      this.expiredShow = false
      // 指定的tab显示为true.
      if (type === 'valid') {
        this.validShow = true
        this.myCouponList = this.myValidCouponList
      } else if (type === 'used') {
        this.usedShow = true
        this.myCouponList = this.myUsedCouponList
      } else if (type === 'expired') {
        this.expiredShow = true
        this.myCouponList = this.myExpiredCouponList
      }
      if (this.myCouponList === 'undefined' || this.myCouponList === undefined || JSON.stringify(this.myCouponList) === '{}') {
        this.couponShow = false
        this.couponEmptyShow = true
      } else {
        this.couponEmptyShow = false
        this.couponShow = true
      }
    },
    gotoHome () {
      // this.$router.push({name: 'Home', query: {'source': this.source}})
      var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
      }
      this.$router.push({name: 'Home', params: {'querys': newQuerys}})
    },
    explainZhDiaShow (key) {
      this.cur = key
      this.explainZhDia = true
    },
    explainEnDiaShow (key) {
      this.cur = key
      this.explainEnDia = true
    },
    goback: function () {
      var LoginWebsiteAddress = sessionStorage.getItem('LoginWebsiteAddress')
      if (LoginWebsiteAddress !== null && LoginWebsiteAddress.indexOf('login/login') === -1) {
        window.document.location.href = LoginWebsiteAddress
      } else {
        var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
        if (this.conver === 1 || this.conver === '1') {
          newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
        }
        this.$router.push({name: 'Home', params: {'querys': newQuerys}})
      }
    }
  }
}
</script>

<style scoped>
.el-main{text-align: left;}
.home_button_zh{width:96px;height:36px;font-size:14px; border:none;border-radius:4px; text-decoration:none;background-color:#4F4C4C;color:#FFF; margin-top:20px;}
.home_button_en{width:159px;height:36px;font-size:14px; border:none;border-radius:4px; text-decoration:none;background-color:#4F4C4C;color:#FFF; margin-top:20px;}
.home_button_en:hover,.home_button_zh:hover{background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);}
.main{background-color: #fff;width:100%;position:relative;background:#FFFFFF;}
.marginnone{margin-right:0px !important;}
/* 右侧 */
.account-show{width: 100%; height: 100%;background:#F2F2F2;}
.account-show .account-center{width: 82%;height:100%; float:right;background: #FFFFFF;}
.account-center .account-data-info{width:100%;height:100%;margin:0 auto;}
.account-data-info .home-coupon{width:100%;}

 /* 状态搜索 */
.account-data-status{width: 100%; height: 60px; margin-top: 30px;}
.account-data-status .account-data-status-center{width: 100%; height: 40px; background:white;margin:0 auto;border-radius: 5px;box-shadow: 1px 1px 2px #dcdfe2;}
.account-data-status-center div:hover{color:#5392F9;}
.account-data-status-center div{cursor: pointer; width: 33.3%;height: 100%;text-align: center;line-height: 40px;float: left;font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;font-weight: 650;font-style: normal;font-size: 14px;color: #303133;box-shadow: 1px 0 1px #dcdfe2;overflow: hidden; white-space: nowrap;}
.account-data-status-center .status-first{border-radius: 5px 0px 0px 5px;}
.account-data-status-center .status-last{border-radius: 0px 5px 5px 0px;}
.account-data-status-center .status-active{background:#5392F9;color:white;}
.account-data-status-center .status-active:hover{color:white;}

/* 优惠券 */
.home-coupon-empty{width:80%;margin:0 auto;min-height:600px;text-align: center;padding-top: 60px;}
/* .empty-text{font-size: 16px;font-weight: 500; color: #4F4C4C;text-align: center; margin-top: 10px;} */
.empty-img{width:260px; height:260px;}
.coupon-back{background-image: url('/static/img/account/u162.svg');position: relative;width: 825px;height: 190px;background-size: 100% 190px;}
.dotted-line{position: absolute;top: 80px;left: 170px;transform: rotate(90.00970244368241deg);}
.coupon-pc img{width:100%; height:190px; margin: 0 auto;position: unset;}
.coupon-money{ height: 169px;width: 213px;margin-left: 12px;float: left;margin-top: 5px;line-height: 169px;text-align: center;} /* height: 165px; width: 180px; margin-left: 15px; float: left; */
.coupon-code{width: 20px !important; height: 28px !important;}
.coupon-price{font-weight: 700;font-size: 80px; color: #00A768;}
.coupon-info{width: 50%;float: left; margin: 22px 0px 0px 40px; float: left;}
.coupon-info-onlytitle{ width: 44%;float: left;margin-left: 40px;float: left;height: 169px;line-height: 169px;}
.coupon-title{font-weight: 400;font-size: 20px;color: #555555; margin: 8px 0px;}
.coupon-text-black{font-weight: 500; color: #555555;text-align: left;}
.coupon-text-gary{font-weight: 400;color: #AAAAAA;}
.coupon-title-twoline{font-weight: 500;font-size: 14px;color: #555555; margin: 2px 0px;height: 40px;line-height: 40px;}

/* 按钮 */
.coupon-button{float: right;height: 180px;margin-right: 3%;}
.coupon-button-info{margin-top: 73px;width: 107px;height: 34px; border-width: 0px;border: none;border-radius: 4px; color:#FFF; text-align: center; line-height: 34px;}
.coupon-button-info-valid{ background-color: #5392F9;}
.coupon-button-info-used{ background-color:rgba(245, 154, 35, 1);}
.coupon-button-info-expired{ background-color:rgba(170, 170, 170, 1);}

/* 手机端-优惠券 */
.empty-img-mobile{width:200px; height:200px;}
.empty-text{font-size: 14px;color: #4F4C4C; text-align: center; margin-top: 10px;}
.coupon-back-mobile{ background-image: url(/static/img/account/u162.svg); position: relative; width: 100%; height: 126px; background-size: 100% 126px;}
.coupon-code-mobile{width: 10px !important; height: 14px !important;}
.coupon-price-mobile{font-weight: 700;font-size: 40px; color: #00A768;}
.dotted-line-mobile{position: absolute;top: 50px;left: 75px;transform: rotate(90.00970244368241deg);}
.coupon-money-mobile{height: 115px;width: 27%;margin-left: 5px; float: left; padding-top: 2px;line-height: 115px;text-align: center;}
.coupon-info-mobile{width: 48%;float: left; margin: 4px 0px 0px 15px; float: left;}
.coupon-info-onlytitle-mobile{ width: 48%;float: left;margin-left: 15px;float: left;height: 95px;line-height: 95px;}
.coupon-title-twoline-mobile{font-weight: 500;font-size: 14px;color: #555555;margin: 2px 0px; height: 50px;line-height: 50px;}
.coupon-title-mobile{font-weight: 500;font-size: 14px;color: #555555; margin: 8px 0px 4px 0px; height: 40px;}
.explain-info{font-size: 10px;} /* overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width:80%; */

/* 手机端-按钮 */
.coupon-button-mobile{font-size: 10px;height: 93px;float: right; margin-right: 8px; margin-top: 4px;}
.coupon-button-info-mobile{padding: 2px 5px; margin-top: 35px;height: 20px; border-width: 0px;border: none;border-radius: 4px; color:#FFF; text-align: center; line-height: 20px;}
/* 响应式 */
    @charset "UTF-8";

    /* @media only screen and (max-width:550px){
        .main .menu-main{display:none}
        .main .account-show .account-center{width:100%;}
        .main .account-show .account-center .account-data-info{width:95%;}

        .coll-collection-pc .row-col{width:100%;}
    }

    @media only screen and (min-width:550px) and (max-width:790px){
        .main .menu-main{display:none}
        .main .account-show .account-center{width:100%;}
        .main .account-show .account-center .account-data-info{width:95%;}

        .coll-collection-pc .row-col{width:50%;}
    } */

    @media screen and (max-width: 1099px) {
    .main .menu-main{display:none}
    .main .account-show .account-center{width:100%;}
    .main .account-show .account-center .account-data-info{width:95%;}
    .coll-collection-pc .el-card{height:90px !important;}
    .coll-collection-pc .row-col{width:100%;}
    .coll-collection-pc .collect-img{width: 30%;float: left; height:90px;}
    .hotel-name{margin: 0; height: 40px;}
    .coll-collection-pc .row-col{margin-bottom: 5px;}
    .coll-collection-pc .el-card{margin: 0;}
    }

    @media only screen and (min-width:1100px){
    .el-main{width:1100px;margin:60px auto;}
    .main{background-color: #fff;position:relative;width:100%; margin: auto;}
    /* .menu-main{width: 255px;height: 100%;float: left;background-color: rgba(255, 255, 255, 1);border-right: none;-webkit-box-shadow: 0 2px 12px #ccc;box-shadow: 4px -2px 5px -3px #ccc;position: fixed;top: 60px;bottom: 300px;} */
    .menu-main{width: 255px;float: left;position: fixed;top: 60px;bottom: 360px;height: 100%}
    .main .account-show .account-center{width:100%;}
    .main .account-show .account-center .account-data-info{width:100%;}
    .main .account-show .account-center .account-data-info .account-order-pc{}
    .main .account-show .account-center .account-data-info .account-order-mobile{display:none;}
    .account-show{width: 825px; height: 100%;background:#FFFFFF;float: right;padding: 0 10px;}
    .coll-collection-pc .row-col{width:25%;}
    }
</style>
<style lang="css" scoped>
.el-tooltip__popper{max-width:185px !important;}
</style>



// WEBPACK FOOTER //
// src/components/account/myCoupon.vue